import { gql } from '@fdc/__generated__/gql';

export const SAVE_FAVOURITE_RECIPE = gql(/* GraphQL */ `
  mutation SaveFavouriteRecipe($input: SaveFavouriteRecipeInput!) {
    saveFavouriteRecipe(input: $input) {
      errors {
        message
      }
      favouriteRecipe {
        recipeId
        shopperId
        modifiedAt
      }
    }
  }
`);
